import {AuthAction, AuthActionEnum, AuthState} from "./types";
import {IUser} from "../../../models/IUser";
import {ITutorial} from "../../../models/ITutorial";
import {ICpuStory} from "../../../models/ICpuStory";
import {IBoxArray} from "../../../models/IBoxArray";
import {INutakuBoxArray} from "../../../models/INutakuBoxArray";


const initialState: AuthState = {
    route: 'home',
    uniqId: '',
    isAuth: false,
    error: '',
    isLoading: false,
    user: {} as IUser,
    //tutorial: {isActive:true, step: 'ClickOffers95'} as ITutorial,
    tutorial: {isActive:false, step: 'none'} as ITutorial,
    cpuStory : {story:null, cpuId:null, cpuNumber:null, action:null} as ICpuStory,
    music: {playMusic: true, playTutorial:true, playMenu:true, playBattle:true},
    boxes: {} as IBoxArray,
    nutakuBoxes : {} as INutakuBoxArray,
    openBox: false,
    cards: {},
    promoSocial: false,
    cardBigSize: false,
    systemMessage: {isVisible:false, type:'', text: '', action: null, actionCancel: null},
    inQueue: false,
    deckEditorFilter: {type:'all',rarity:'all'},
    globalLoading: false,
    globalError: null
}

export default function authReducer(state = initialState, action: AuthAction): AuthState {
    switch (action.type) {
        case AuthActionEnum.SET_GLOBAL_ERROR:
            return {...state, globalError: action.payload}
        case AuthActionEnum.SET_GLOBAL_LOADING:
            return {...state, globalLoading: action.payload}
        case AuthActionEnum.SET_UNIQ_ID:
            return {...state, uniqId: action.payload}
        case AuthActionEnum.SET_ROUTE:
            return {...state, route: action.payload}
        case AuthActionEnum.SET_AUTH:
            return {...state, isAuth: action.payload, isLoading: false}
        case AuthActionEnum.SET_USER:
            return {...state, user: action.payload}
        case AuthActionEnum.SET_TUTORIAL:
                return {...state, tutorial: action.payload}
        case AuthActionEnum.SET_ERROR:
            return {...state, error: action.payload, isLoading: false}
        case AuthActionEnum.SET_IS_LOADING:
            return {...state, isLoading: action.payload}
        case AuthActionEnum.SET_CPU_STORY:
            return {...state, cpuStory: action.payload}
        case AuthActionEnum.SET_MUSIC:
            return {...state, music: action.payload}
        case AuthActionEnum.SET_BOXES:
            return {...state, boxes: action.payload}
        case AuthActionEnum.SET_NUTAKU_BOXES:
            return {...state, nutakuBoxes: action.payload}
        case AuthActionEnum.SET_OPENBOX:
            return {...state, openBox: action.payload}
        case AuthActionEnum.SET_CARDS:
            return {...state, cards: action.payload}
        case AuthActionEnum.SET_PROMO_SOCIAL:
            return {...state, promoSocial: action.payload}
        case AuthActionEnum.SET_CARD_BIG_SIZE:
            return  {...state, cardBigSize: action.payload}
        case AuthActionEnum.SET_SYSTEM_MESSAGE:
            return {
                ...state,
                systemMessage: {
                    actionCancel: null,
                    ...action.payload
                }
            }
        case AuthActionEnum.SET_IN_QUEUE:
            return {...state, inQueue: action.payload}
        case AuthActionEnum.SET_DECK_EDITOR_FILTER:
            return {...state, deckEditorFilter: action.payload}
        default:
            return state;
    }
}
